/** Versioned cookie / personal-data processing consent (152-FZ). */
export const COOKIE_CONSENT_STORAGE_KEY = 'tsovetnik.cookieConsent';
export const COOKIE_CONSENT_VERSION = '2';

export type CookieConsentRecord = {
  version: string;
  acceptedAt: string;
};

export function readCookieConsent(): CookieConsentRecord | null {
  if (typeof localStorage === 'undefined') return null;
  try {
    const raw = localStorage.getItem(COOKIE_CONSENT_STORAGE_KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<CookieConsentRecord>;
    if (
      typeof parsed.version !== 'string' ||
      typeof parsed.acceptedAt !== 'string' ||
      !parsed.acceptedAt
    ) {
      return null;
    }
    return { version: parsed.version, acceptedAt: parsed.acceptedAt };
  } catch {
    return null;
  }
}

export function hasCookieConsent(version = COOKIE_CONSENT_VERSION): boolean {
  const rec = readCookieConsent();
  return rec?.version === version;
}

export function acceptCookieConsent(version = COOKIE_CONSENT_VERSION): CookieConsentRecord {
  const rec: CookieConsentRecord = {
    version,
    acceptedAt: new Date().toISOString(),
  };
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem(COOKIE_CONSENT_STORAGE_KEY, JSON.stringify(rec));
  }
  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent('tsovetnik:cookie-consent', { detail: rec }));
  }
  return rec;
}
